module.exports = __webpack_public_path__ + "static/bill-11829f05d49eb0b0e60f851f4f36a91b.jpg";